import axios from 'axios';
import qs from 'qs';
import { destroyToken, getToken, saveToken } from '@/services/jwt.service';
import authApi from '@/services/api/authApi';

const baseURL = process.env.VUE_APP_BASE_API_URL;
const axiosInstance = axios.create({ baseURL });

axiosInstance.defaults.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (resp) => resp.data,
  (err) => {
    const originalRequest = err.config;

    if (err?.message === 'canceled') {
      return err;
    }
    if (err.response?.status >= 500) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: { errors: [err.response.status] },
      });
    }
    if (err.response?.status === 401) {
      // eslint-disable-next-line no-underscore-dangle
      originalRequest._retry = true;
      return authApi.refreshAccessToken()
        .then((resp) => {
          const { access_token: accessToken, refresh_token: refreshToken } = resp.data;
          saveToken({ accessToken, refreshToken });
          return axiosInstance(originalRequest);
        }).catch(() => {
          destroyToken();
          window.location.reload();
        });
    }
    if (err.response) {
      return Promise.reject(err.response);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      data: { errors: ['Ошибка соединения с сервером'] },
    });
  },
);

export default axiosInstance;
